import { httpGet } from "@/api/connection.js";
import {
  GetEventTypesFn,
  GetEventTypesParams,
  GetEventTypesResponse,
} from "./eventTypes.types";
import { queryClient } from "@/index";

const queryKey: unknown[] = ["event-types", "list"];

const eventTypesQueryKeys = {
  all: ["event-types", "list"],
  list: (query?: GetEventTypesParams) => ["event-types", "list", query],
  infiniteList: (query?: GetEventTypesParams) => [
    "event-types",
    "infinite-list",
    query,
  ],
};

const get: GetEventTypesFn = async (values = {}) => {
  return httpGet("/analysis/event-types", values);
};

const getCached: (
  p?: GetEventTypesParams
) => GetEventTypesResponse | undefined = (params) => {
  if (params) {
    queryKey.push(params);
  }

  const cacheData = queryClient.getQueryData(queryKey) as
    | GetEventTypesResponse
    | undefined;

  return cacheData;
};

const setCached = (
  data: GetEventTypesResponse,
  params?: GetEventTypesParams
) => {
  if (params) {
    queryKey.push(params);
  }

  queryClient.setQueryData(queryKey, data);

  return;
};

export const EventTypesAPI = {
  queryKey,
  queryKeys: eventTypesQueryKeys,
  get,
  getCached,
  setCached,
};
